








import Component from 'vue-class-component'
import { Hooks } from '@/shared/interfaces/hooks'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import { Injector } from '@/config/dependency-injection'
import { ResourceModule } from '@/business/resource/store/resource-module'
import { ResourceViewModel } from '@/business/resource/interfaces/resource-view-model'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { FETCH_RESOURCE } from '@/business/resource/store/types'
import DefaultHeader from '@/main/default-header.vue'

@Component({
  name: 'resource-page',
  components: { DefaultHeader },
})
export default class ResourcePage extends Vue implements Hooks {
  @Prop({
    required: true,
    type: Number,
  })
  public readonly id!: number

  private loaderHelper = Injector.get(LoaderHelper)
  private resourceModule = Injector.get(ResourceModule)

  public get loading() {
    return this.loaderHelper.isLoading(FETCH_RESOURCE)
  }

  public get resource(): ResourceViewModel {
    return this.resourceModule.data.resource
  }

  public mounted() {
    this.resourceModule.fetchResource({
      resourceId: this.id,
    })
  }
}
